import { render, staticRenderFns } from "./PostageSelects.vue?vue&type=template&id=564bcdab&scoped=true"
import script from "./PostageSelects.vue?vue&type=script&lang=js"
export * from "./PostageSelects.vue?vue&type=script&lang=js"
import style0 from "./PostageSelects.vue?vue&type=style&index=0&id=564bcdab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564bcdab",
  null
  
)

export default component.exports